export default __webpack_public_path__ + "static/media/FB.31d2bb45.svg";